
import React from 'react';
import ReactDOM from 'react-dom';
import swal from 'sweetalert';

class CodesEdit extends React.Component
{
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.save = this.save.bind(this);
        this.renderCodes = this.renderCodes.bind(this);

        this.state = {
            batch: {},
            available: null,
            unavailable: null,
            product: {},
            successRegister: false
        };
    }

    componentWillMount()
    {
        let self = this;
        let id = self.props.id_batch;

        axios.get('/api/codes/resume/' + id)
            .then(response => {
                self.setState({
                    batch: response.data.batch,
                    product: response.data.product,
                    available: response.data.available,
                    unavailable: response.data.unavailable
                });
            })
            .catch(error => {
                swal({
                    title: "¡Oh no!",
                    text: "Ha ocurrido un error al intentar procesar tu solicitud.",
                    icon: "warning",
                });
            });
    }

    componentDidMount()
    {
        let self = this;
    }


    handleChange({target})
    {
        let self = this;

        let product = self.state.product;
        product[target.id] = target.value;

        self.setState({
            product: product
        });
    }

    save()
    {
        let self = this;

        let request = self.state.product;

        /*
        axios.post('/api/products/update', request)
            .then(response => {
                location.reload();
            })
            .catch(error => {
            });
           */
    }

    renderCodes(item)
    {
        let pin = item.pin === "" ? "Sin pin asignado": item.pin;
        let user = "";

        if (item.user === null)
            user = "Sin asignar";
        else
            user = item.user.name + '-' + item.user.tdc;

        let total = parseInt(this.state.available) + parseInt(this.state.unavailable);

        return(
            <div>
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th>Status</th>
                        <th>Total</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Disponibles</td>
                        <td>
                            <p className="btn btn-success">
                                <i className="fa fa-check"></i> {this.state.available}
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>Asignados</td>
                        <td>
                            <p className="btn btn-warning">
                                <i className="fa fa-times"></i> {this.state.unavailable}
                                </p>
                        </td>
                    </tr>
                    <tr>
                        <td>Total</td>
                        <td>
                            <p className="btn btn-info">{total}</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    render()
    {
        let self = this;
        let batch_notes = self.state.batch.notes === null ? "Sin notas": self.state.batch.notes;
        let total = 0;
        total = parseInt(this.state.available) + parseInt(this.state.unavailable);

        return (
            <div>
                <div className="col-sm-12">
                    <h4 className="page-title">Editar un lote de códigos</h4>
                    <ol className="breadcrumb">
                        <li>
                            <a href="/">Home</a>
                        </li>
                        <li>
                            <a href="/codes">Códigos</a>
                        </li>
                        <li className="active">
                            Editar
                        </li>
                    </ol>
                </div>

                <div className="row">
                    <div className="col-md-5">
                        <div className="panel panel-default">
                            <div className={"panel-header"}>
                            </div>
                            <div className="panel-body">
                                <div className="col-md-10">
                                    <h4 className="m-t-0 header-title"><b>Detalles del lote</b></h4>

                                    <form role="form" id="batchForm">
                                        <div className="form-group">
                                            <label htmlFor="key">Key</label>
                                            <p className="form-control" id="key"
                                                   onChange={this.handleChange}>
                                                {this.state.batch.key}
                                            </p>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="description">Descripción</label>
                                            <p className="form-control" id="description"
                                                   onChange={this.handleChange}>
                                                {this.state.batch.description}
                                            </p>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="productLink">Producto asociado</label>
                                            <p className="form-control" id="productLink"
                                                   onChange={this.handleChange}>
                                                {this.state.product.key + ' - ' + this.state.product.description}
                                            </p>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="created_at">Fecha de creación</label>
                                            <p className="form-control" id="created_at"
                                                   onChange={this.handleChange}>
                                                {this.state.batch.created_at}
                                            </p>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="notes">Notas</label>
                                            <textarea className="form-control" id="notes"
                                                   onChange={this.handleChange} readOnly={true}>
                                                {batch_notes}
                                            </textarea>
                                        </div>

                                        <button type="button"
                                                className="btn btn-purple waves-effect waves-light pull-right"
                                                id="productRegisterButton" onClick={this.save}
                                                disabled={true}>
                                            <i className="fa fa-save"></i> Guardar
                                        </button>
                                    </form>

                                    {
                                        this.state.successRegister &&
                                        <div>
                                            <a href="/products"
                                               className="btn btn-success waves-effect waves-light pull-right">
                                                <i className="fa fa-arrow-circle-o-left"></i> Regresar a productos
                                            </a>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="panel panel-default">
                            <div className={"panel-header"}>
                            </div>
                            <div className="panel-body">
                                <h4 className="m-t-0 header-title"><b>Códigos asociados</b></h4>
                                <br/>
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <th>Status</th>
                                        <th>Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Disponibles</td>
                                        <td>
                                            <p className="btn btn-block btn-success">{this.state.available}</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Asignados</td>
                                        <td>
                                            <p className="btn btn-block btn-warning">{this.state.unavailable}</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Total</td>
                                        <td>
                                            <p className="btn btn-block btn-info">{total}</p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                <div className="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        );
    }
}

export default CodesEdit;

if (document.getElementById('codes_edit-component')) {
    ReactDOM.render(<CodesEdit id_batch={id_batch}/>, document.getElementById('codes_edit-component'));
}



// WEBPACK FOOTER //
// ./resources/assets/react/CodesEdit.jsx